import React from "react";

const EmailIcon = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 17.2917H5C2.985 17.2917 1.875 16.1817 1.875 14.1667V6.66669C1.875 4.65169 2.985 3.54169 5 3.54169H15C17.015 3.54169 18.125 4.65169 18.125 6.66669V14.1667C18.125 16.1817 17.015 17.2917 15 17.2917ZM5 4.79169C3.68583 4.79169 3.125 5.35252 3.125 6.66669V14.1667C3.125 15.4809 3.68583 16.0417 5 16.0417H15C16.3142 16.0417 16.875 15.4809 16.875 14.1667V6.66669C16.875 5.35252 16.3142 4.79169 15 4.79169H5ZM10.8575 10.9825L14.9508 8.00585C15.2299 7.80335 15.2916 7.41169 15.0883 7.13253C14.8858 6.85419 14.4959 6.79085 14.2151 6.99502L10.1217 9.97169C10.0483 10.025 9.95086 10.025 9.87752 9.97169L5.7841 6.99502C5.50243 6.79085 5.11339 6.85503 4.91089 7.13253C4.70756 7.41169 4.76925 7.80252 5.04842 8.00585L9.14164 10.9833C9.39831 11.17 9.69919 11.2625 9.99919 11.2625C10.2992 11.2625 10.6017 11.1692 10.8575 10.9825Z"
      fill="#7A7A7A"
    />
  </svg>
);

export default EmailIcon;
